module.exports = __webpack_public_path__ + "assets/dienst1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/documentation/images/dienst1.jpg
// module id = 357
// module chunks = 0